const user_agent = navigator.userAgent.toLocaleLowerCase();
/**
 * 获取url参数
 *
 * @param {any} 参数key值
 * @returns
 */
function getQueryString(key) {
        let url = window.location.href;
        // let url='http://h5.91idu.com/articleDetail.html?id=72&token=bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC90ZXN0YXBpLjkxaWR1LmNvbVwvYXBpXC92MVwvbG9naW4iLCJpYXQiOjE1ODI2MjE4MTUsIm5iZiI6MTU4MjYyMTgxNSwianRpIjoiMHFSdmI3N1FnaTFadlVmYyIsInN1YiI6NjE5LCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3IiwiZ3VhcmQiOiJhcGkifQ.I3Mqf-v5xJnba_fJDrr0NhnDLTL12eUCiCkqkOeQ9aI'
        // let url='http://h5.91idu.com/vedioShare.html?id=6&chapter_id=41&token=bearereyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9hcGkuOTFpZHUuY29tXC9hcGlcL3YxXC9sb2dpbiIsImlhdCI6MTU3ODI4Nzk4OCwibmJmIjoxNTc4Mjg3OTg4LCJqdGkiOiJ2RWt1aGdYbnZBQ1NNek9KIiwic3ViIjoyMiwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyIsImd1YXJkIjoiYXBpIn0.Fv_9VdULY4PokkJDaUoWbbMcpsqd5idR96hJ3V0Xr5o'
        // let url='http://h5.91idu.com/audioShare?id=2'
        let theRequest = {};
    if (url.indexOf('?') !== -1) {
        let str = url.substr(url.indexOf('?')+1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
        }
    }
    return theRequest[key] == null ?theRequest: theRequest[key];
}
/**
 * 是否android系统
 *
 * @returns
 */
function isAndroid() {
    return (/android/i).test(user_agent);
}
/**
 * 是否ios系统
 *
 * @returns
 */
function isIOS() {
    return (/iphone/i).test(user_agent) || (/ipad/i).test(user_agent) ||
        (/ios/i).test(user_agent);
}
//获取滚动条高度
function getScrollTop() {
    let scrollTop = 0;
    if(document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
    } else if(document.body) {
        scrollTop = document.body.scrollTop;
    }
    return scrollTop;
}
//获取当前可视范围的高度
function getClientHeight() {
    let clientHeight = 0;
    if(document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
    } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
    }
    return clientHeight;
}
//获取文档完整的高度
function getScrollHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
}
function setStorage (name, content) {
    if (!name) return
    if (typeof content !== 'string') {
        content = JSON.stringify(content)
    }
    window.sessionStorage.setItem(name, content)
}
// 获取localStorage
function getStorage (name) {
    if (!name) return
    return window.sessionStorage.getItem(name)
}
export default {
    getQueryString:getQueryString,
    isAndroid:isAndroid,
    isIOS:isIOS,
    getScrollTop:getScrollTop,
    getClientHeight:getClientHeight,
    getScrollHeight:getScrollHeight,
    setStorage:setStorage,
    getStorage:getStorage,
}
